import {FC} from "react";
import {PortfolioItemType} from "../../store/reducer";


export const PortfolioItem:FC<{item:PortfolioItemType}> = ({item}) => {
    return <div className={'portfolio_item'}>
        <img src={'./assets/images/portfolio/' + item.img} alt=""/>
        <div className="portfolio_item__content">
            <h2>{item.name}</h2>
            <div className="portfolio_item__links">
                <a href={item.url} target={'_blank'}>site</a>
                {item.github && <a href={item.github} target={'_blank'}>code</a>}
            </div>
            <div className="portfolio_item__tags">
                {item.tags.map((tag,idx) => <div  key={idx}><h3>{tag}</h3></div>)}
            </div>
        </div>
    </div>
}